const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/services.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/services')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});